import axios from "axios";
import { API_URL, emailValidationRegex } from "const/common";
import { useRouter } from "next/router";
import { useState } from "react";
import { useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import Container from "../common/Container";
import Title from "../common/Title";

const InquirySection = ({ buttonName, id, className }) => {
  const [phoneValue, setPhoneValue] = useState("");
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [disable, setDisable] = useState(false);
  const router = useRouter();
  const pathname = router.asPath;

  const onSubmit = (values) => {
    const { name, email, message, companyName } = values;
    const formattedMessage = message?.toString().replace(/\r?\n/g, "<br />");
    if (Object.keys(errors).length === 0) {
      setDisable(true);
      axios
        .post(`${API_URL}admin/contactusdata`, {
          ...values,
          name,
          email,
          message: formattedMessage,
          phone: phoneValue,
          companyName,
          enquiryPage: pathname,
          isDataScraping: true,
        })
        .then(() => {
          reset();
          router.push("/thankyou");
        })
        .finally(() => {
          setDisable(false);
        });
    }
  };
  return (
    <Container large className={`${className} bg-primary-black pt-20 md:pt-40`}>
      <div
        id={id}
        className="flex flex-col xl:flex-row justify-between rounded-2xl py-20 px-4 md:py-12 md:px-9 bg-white/5 scroll-m-28"
      >
        <div className="w-full md:w-1/3 pb-12">
          <Title
            description="kickstart your journey towards success! Reach out to us and let&'s turn your ideas
into reality."
            descriptionClass="text-sm md:text-base text-white mb-0"
            subTitle="Ready to get started?"
            subTitleClass="text-4xl md:text-6xl text-white mb-6 font-medium md:leading-tight"
          />
        </div>
        <div className="w-full md:w-7/12">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col xl:flex-row gap-4 pb-12 xl:mb-4">
              <div className="flex flex-col justify-between md:w-1/2">
                <input
                  id="name"
                  {...register("name", { required: true })}
                  autoComplete="off"
                  className="w-full py-2 lg:py-4 px-6 rounded-lg border border-solid border-black/5 text-sm md:text-lg focus-visible:outline-none"
                  placeholder="Full Name*"
                />
                {errors.name && (
                  <p className="mt-2 ms-2 text-red-600">
                    <span>Name is required</span>
                  </p>
                )}

                <div className="w-full mt-4 rounded-lg border border-solid border-black/5 dataSolutionForm">
                  <PhoneInput
                    placeholder="Contact no"
                    country={"us"}
                    enableSearch={true}
                    value={phoneValue}
                    onChange={(value) => setPhoneValue(value)}
                  />
                </div>
                {errors.phone && (
                  <p className="text-danger mt-2 mb-0 ms-2">
                    Enter a valid phone number
                  </p>
                )}
                <input
                  autoComplete="off"
                  className="w-full mt-4 py-2 lg:py-4 px-6 rounded-lg border border-solid border-black/5 text-sm md:text-lg focus-visible:outline-none"
                  id="Company Name"
                  placeholder="Company Name"
                  {...register("companyName")}
                />
              </div>
              <div className="w-full md:w-1/2 flex flex-col justify-between">
                <input
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: emailValidationRegex,
                      message: "Enter valid email",
                    },
                  })}
                  autoComplete="off"
                  className="w-full py-2 xl:py-4 pl-6 rounded-lg border border-solid border-black/5 text-sm md:text-lg focus-visible:outline-none"
                  id="email"
                  placeholder="Email ID*"
                />
                {errors.email && (
                  <p className="text-red-600 ms-2 mt-2">
                    <span>{errors?.email?.message}</span>
                  </p>
                )}
                <textarea
                  {...register("message", { required: true })}
                  className="mt-4 rounded-lg border border-solid border-black/5 text-sm md:text-lg focus-visible:outline-none pt-3 pb-3 pl-6 md:py-3 md:px-6"
                  placeholder="Message*"
                  rows={4}
                />
                {errors.message && (
                  <p className="text-red-600 mt-2 mb-0 ms-2">
                    <span>Message is required</span>
                  </p>
                )}
              </div>
            </div>
            <div className="flex justify-center">
              <button
                className="font-500 rounded-lg py-3 px-10 md:py-4 md:px-14 text-lg bg-primary-yellow text-white transition-all ease-out duration-500 border border-solid border-primary-yellow hover:bg-transparent hover:text-primary-yellow hover:ease-in"
                onClick={handleSubmit(onSubmit)}
                disabled={disable}
              >
                <span>{buttonName}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </Container>
  );
};

export default InquirySection;
